var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"md-3"},[_c('b-row',[_c('b-col',{staticClass:"align-left"},[_c('p',[_vm._v("Estados de los nodos")])])],1),_c('b-card-text',{staticClass:"deviceStatusTable"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"isLoading":_vm.isLoading,"search-options":{
        enabled: true,
        //trigger: 'enter',
        skipDiacritics: true,
        //searchFn: mySearchFn,
        placeholder: 'Buscar en la tabla',
        //externalQuery: searchQuery
        },"sort-options":{
          enabled: true,
          initialSortBy: {field: 'device.uuid', type: 'asc'}
        },"pagination-options":{
            enabled: true,
            mode: 'records',
            perPage: 10,
            dropdownAllowAll: false,
            //setCurrentPage: 2,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: 'Filas por pagina',
            ofLabel: 'de',
            pageLabel: 'pagina', // for 'pages' mode
            allLabel: 'Todas',
          }},on:{"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'updated')?_c('span',[_vm._v("\n              "+_vm._s(_vm.getUpdatedFormatted(props.row.updated))+"\n            ")]):(props.column.field == 'lastUpdated')?_c('span',[_vm._v("\n              "+_vm._s(_vm.getDateFormatted(props.row.lastUpdated))+"\n            ")]):(props.column.field == 'lastSent')?_c('span',[_vm._v("\n              "+_vm._s(_vm.getDateFormatted(props.row.lastSent))+"\n            ")]):_vm._e()]}}])},[_c('template',{slot:"loadingContent"},[_c('table-loading')],1),_c('template',{slot:"emptystate"},[_c('table-empty-state')],1)],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }